import TripLocalityProperty from "../../../views/TripLocalityProperty";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const TripLocalityPropertyRoutes = [
  {
    menuName: MenuNames.TRIP_LOCALITY_PROPERTY,
    path: "/trip-locality-property-bulk-upload",
    component: TripLocalityProperty,
    exact: true,
  },
];

export default TripLocalityPropertyRoutes;
